import { createContext, useContext } from 'react';

const ListingContext = createContext();

export const ListingProvider = ({ children, value }) => (
  <ListingContext.Provider value={value}>{children}</ListingContext.Provider>
);

export const useListingContext = () => {
  const ctx = useContext(ListingContext);
  if (!ctx) throw new Error('useListingContext must be used within ListingProvider');
  return ctx;
};
